import Button from '@mui/material/Button';
import Image from 'components/Image';
import { useEffect, useState } from 'react';
import writeImg from '../../images/write.svg';
import Link from '@mui/material/Link';
import DashboardCard from './DashboardCard';

const sample = require('lodash.sample');

export default function FirstPostCard({ isGrid, title }) {
  const [quote, setQuote] = useState({ text: '', author: '' });

  useEffect(() => {
    const newQuote = sample([
      {
        text:
          'Start writing, no matter what. The water does not flow until the faucet is turned on.',
        author: "Louis L'Amour",
      },
      {
        text:
          "This is how you do it: you sit down at the keyboard and you put one word after another until it's done. It's that easy, and that hard.",
        author: 'Neil Gaiman',
      },
      {
        text:
          'Writing is easy. All you have to do is cross out the wrong words.',
        author: 'Mark Twain',
      },
      {
        text: 'You can always edit a bad page. You can’t edit a blank page.',
        author: 'Jodi Picoult',
      },
      {
        text:
          'There is no greater agony than bearing an untold story inside you.',
        author: 'Maya Angelou',
      },
      {
        text: 'A professional writer is an amateur who didn’t quit.',
        author: 'Richard Bach',
      },
      {
        text:
          'There is nothing to writing. All you do is sit down at a typewriter and bleed.',
        author: 'Ernest Hemingway',
      },
      {
        text: 'If you want to change the world, pick up your pen and write.',
        author: 'Martin Luther',
      },
      {
        text:
          "You can't wait for inspiration. You have to go after it with a club.",
        author: 'Jack London',
      },
    ]);
    setQuote(newQuote);
  }, []);

  return (
    <DashboardCard
      isGrid={isGrid}
      title={title || 'Publish your first post'}
      content={
        <div className="container cardContainer">
          <div className="d-flex flex-wrap flex-xl-nowrap">
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ minWidth: 300 }}
            >
              <div className="pr-2 d-flex flex-grow-1 flex-wrap justify-content-center">
                <div className="postcontent w-100">
                  <blockquote>{quote.text}</blockquote>
                  <p
                    className="ml-5"
                    style={{
                      fontFamily:
                        'medium-content-slab-serif-font, Georgia, Cambria, Times, serif',
                      marginTop: '-10px',
                    }}
                  >
                    <span style={{ color: '#00695C' }}>–</span> {quote.author}
                  </p>
                </div>
                <div className="mt-2" />
                <Link href="/dashboard/publish">
                  <Button variant="contained" color="primary">
                    Start writing
                  </Button>
                </Link>
              </div>
            </div>
            <div className="writeImg d-none d-sm-flex flex-grow-1 justify-content-center justify-content-xl-end mt-3">
              <div className="imgMax300 img-fluid">
                <Image priority src={writeImg} alt="publish post" />
              </div>
              <style jsx>{`
                @media (min-width: 1200px) {
                  .writeImg {
                    max-width: 300px;
                  }
                }
                @media (max-width: 1199px) {
                  .imgMax300 {
                    max-width: 300px;
                  }
                }
              `}</style>
            </div>
          </div>
        </div>
      }
    />
  );
}
